import { colord, extend } from 'colord';
import namesPlugin from 'colord/plugins/names';
import styled from 'styled-components';
import { extractNumber } from '../../../../functions/utils/extractNumber';
import { Dropdown } from '../../Dropdown';
import { ColorSwatch } from '../ColorSwatch';
import { NumberInput } from '../NumberInput';
import { TextInput } from '../TextInput';
import { ColorPickerModalContent } from './ColorPickerModalContent';
extend([namesPlugin]);

export const ColorInput = ({
  value,
  onChange,
  onlySolid,
  defaultSwatchesTarget,
}: {
  value?: string | null;
  onChange: (newValue?: string) => void;
  onlySolid?: boolean;
  defaultSwatchesTarget?: string;
}) => {
  const isGradient = value?.includes('gradient');
  const rgba = colord(value || 'transparent').toRgb();
  const alpha = rgba.a;

  return (
    <>
      <Dropdown
        trigger={
          <ColorSwatchContainer>
            <ColorSwatch value={value} />
          </ColorSwatchContainer>
        }
        closeOnClick={false}
      >
        <DropdownContentContainer>
          <ColorPickerModalContent
            value={value}
            onChange={onChange}
            onlySolid={onlySolid}
            defaultSwatchesTarget={defaultSwatchesTarget}
          />
        </DropdownContentContainer>
      </Dropdown>

      <TextInput
        value={value === null ? 'Mixed' : isGradient ? 'Gradient' : value}
        onBlur={onChange}
        isDisabled={isGradient || value === null}
        inputStyle={{ fontFamily: 'var(--font-3)', fontWeight: 300 }}
      />
      {!isGradient && (
        <NumberInput
          value={Number((alpha * 100).toFixed(0))}
          onChange={(newAlpha) => {
            const extractedNumber = extractNumber(newAlpha);
            if (extractedNumber === null) return;
            rgba.a = Number((extractedNumber / 100).toFixed(2));

            onChange(colord(rgba).toHex());
          }}
          inputStyle={{ textAlign: 'right' }}
          defaultUnit="%"
          units={['%']}
          style={{ maxWidth: '60px' }}
        />
      )}
    </>
  );
};

const ColorSwatchContainer = styled.div`
  padding-left: 6px;
`;

const DropdownContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 5px;
  margin-left: 6px;

  background-color: var(--neutral-2);
  border: 1px solid var(--neutral-3);
  border-radius: var(--radius-2);

  box-shadow: var(--shadow-1);
`;
